import defaultColors from '#rsu/styles/default/colors';

const styleProperties = {
    widthLeftPanel: '320px',
    widthRightPanel: '256px',
    widthRightPanelLarge: '360px',
    widthNavbarRight: '50px',
    widthResponseFilters: '240px',
    heightHeader: '108px',
    heightNavbar: '48px',
    heightTableHeader: '25px',
    heightContent: 'calc(100vh - 48px - 144px)',
    colorAccent: '#0080c2',
    colorAccentLight: 'rgba(0, 128, 194, .05)',
    colorAccentMediumLight: 'rgba(0, 128, 194, .2)',
    colorAccentMediumLightAlt: 'rgba(0, 128, 194, .6)',
    colorBackgroundHover: 'rgba(0, 128, 194, .2)',
    colorNavbarMenuItemHover: defaultColors.colorText,
    colorBackgroundAccentHint: '#ecf6fb',
    colorDangerLight: 'rgba(255,0,0,0.12)',
    colorSeparatorOnPrimary: '#ffffff2e',
    colorHoverOnPrimary: '#ffffffaa',
    colorDangerBright: 'rgb(205, 0, 0)',
    radiusPanelBorder: '5px',
    heightTimelineMainContent: '128px',
    panelBorderRadius: '5px',
    colorBackgroundNewItem: 'rgba(79, 195, 247, .09)',
    colorBackgroundNewItemHover: 'rgba(79, 195, 247, .2)',
    fontSizeUltraLarge: '32px',
    fontSizeUltraLargeAlt: '48px',
    colorBackgroundApp: '#f9f9f9',
    colorButtonBackgroundHover: '#f7f7f7',

    widthHeaderLogo: '72px',
    heightHeaderLogo: '72px',
};

export default styleProperties;
